<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont el-icon-setting"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{$t("systemSetting.updatePage")}}</div>
            </div>
        </div>
        <div class="title_tab">
            <div :class="{title_tab_item: true,  active: active === 0}" @click="handleBtnChange(0)">固件升级</div>
            <div :class="{title_tab_item: true,  active: active === 1}" @click="handleBtnChange(1)">历史记录</div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <template v-if="active === 0">
                <el-form class="tableSearchForm updatePanel" :model="updateForm"  size="medium" label-width="120px" label-position="left" :rules="rules" ref="updateForm"
                         v-loading="formLoading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)"
                >
                    <el-form-item label="设备选择" prop="deviceId">
                        <el-select v-model="updateForm.deviceId" placeholder="请选择" style="width: 200px" popper-class="selectDown" clearable>
                            <el-option v-for="item in options" :key="item.id" :label="item.deviceName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备类型" prop="deviceType">
                        <el-select v-model="updateForm.deviceType" placeholder="请选择" style="width: 200px" popper-class="selectDown" clearable>
                            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="从控设备序号" prop="l1DeviceId">
                        <el-input-number v-model="updateForm.l1DeviceId" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"  :min="0" :max="255" controls-position="right"></el-input-number>
                    </el-form-item>

                    <el-form-item label="主控设备序号" prop="l2DeviceId">
                        <el-input-number v-model="updateForm.l2DeviceId" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"  :min="0" :max="255" controls-position="right"></el-input-number>
                    </el-form-item>

                    <el-form-item label="总控设备序号" prop="l3DeviceId">
                        <el-input-number v-model="updateForm.l3DeviceId" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"  :min="0" :max="255" controls-position="right"></el-input-number>
                    </el-form-item>

                    <el-form-item label="是否重启" prop="reset">
                        <el-radio-group v-model="updateForm.reset">
                            <el-radio :label="1">立即重启生效</el-radio>
                            <el-radio :label="0">稍后重启</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="升级文件" prop="reset">
                        <div class="btn btn_active" style="width: 100px">
                            <el-button type="text" icon="el-icon-upload" @click="handleUpload" class="btnClass">{{ $t('index.upload') }}</el-button>
                        </div>
                        <span style="color: #0acfe6">{{ updateForm.fileName}}</span>
                    </el-form-item>
                </el-form>
                <div style="text-align: center;  width: 100%; margin-top: 20px">
                    <div class="btn btn_active" style=" width: 100px">
                        <el-button type="text" @click="resetForm" class="btnClass">{{ $t('ems.strategy.cancel') }}</el-button>
                    </div>
                    <div class="btn btn_active" style=" width: 100px">
                        <el-button type="text" @click="submitForm" class="btnClass" :disabled="formLoading" :loading="formLoading">{{ $t('ems.strategy.confirm') }}</el-button>
                    </div>
                </div>
            </template>
            <template v-else>
                <el-form @submit.native.prevent class="tableSearchForm" :inline="true" size="small" label-position="left">
                    <el-form-item label="设备选择">
                        <el-select v-model="form.deviceNo" placeholder="请选择" style="width: 200px" popper-class="selectDown" clearable>
                            <el-option v-for="item in options" :key="item.deviceNo" :label="item.deviceName" :value="item.deviceNo"></el-option>
                        </el-select>
                    </el-form-item>
                    <div class="btn btn_active" @click="search"><i class="iconfont icon-sousuo"></i><span>{{ $t('ems.history.search') }}</span></div>
                </el-form>
                <el-table
                        :data="list"
                        style="width: 100%"
                        v-loading="listLoading"
                        border
                        size="small"
                        :height="600"
                        class="BMSTable"
                >

                    <el-table-column  :label="$t('ems.alarm.DeviceName')" prop="deviceName"  align="center" width="150"></el-table-column>
                    <el-table-column  :label="$t('ems.alarm.EquipmentSerialNumber')"  prop="deviceNo"  align="center" width="200"></el-table-column>

                    <el-table-column  label="从控设备序号" prop="l1DeviceId" align="center" width="160"></el-table-column>
                    <el-table-column  label="主控设备序号" prop="l2DeviceId" align="center" width="160"></el-table-column>
                    <el-table-column  label="总控设备序号" prop="l3DeviceId" align="center" width="160"></el-table-column>

                    <el-table-column  label="开始时间" prop="beginTime" align="center" width="160"></el-table-column>
                    <el-table-column  label="结束时间" prop="endTime" align="center" width="160"></el-table-column>
                    <el-table-column  label="升级进度"  align="center" width="100" prop="progress">
                        <template slot-scope="scope">
                            <span :style="{color: 'rgb(68, 209, 234)'}">{{ scope.row.progress }}%</span>
                        </template>
                    </el-table-column>

                    <el-table-column  label="任务状态"  align="center" width="120" prop="status">
                        <template slot-scope="scope">
                            <span style="color: #85500f" v-if="scope.row.status === 2">升级取消</span>
                            <span style="color: #22acff" v-if="scope.row.status === 0"><i class="el-icon-loading" style="font-size: 14px; margin-right: 6px"></i>升级中</span>
                            <span style="color: #17fa10" v-if="scope.row.status === 1"><i class="el-icon-success" style="font-size: 14px;margin-right: 6px"></i>升级成功</span>
                            <span style="color: #c00308" v-if="scope.row.status === 3"><i class="el-icon-error" style="font-size: 14px;margin-right: 6px"></i>升级失败</span>
                        </template>
                    </el-table-column>

                    <el-table-column  :label="$t('ems.operate')" align="center" >
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="onStop(scope.row.id)" type="text" size="small" icon="el-icon-circle-close" v-if="scope.row.status === 0">取消任务</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                            class="pagePagination"
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            layout="total, sizes, prev, pager, next,jumper"
                            :page-size="size"
                            :page-sizes="[ 15, 50, 100 ]"
                            :current-page.sync="page"
                            :total="total"
                            popper-class="selectDown"
                    ></el-pagination>
                    <!--                popper-class-->
                </div>
            </template>

        </div>

        <div v-if="uploadVis">
            <el-dialog :title="$t('index.upload')" :visible.sync="uploadVis" append-to-body width="800px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm"  size="small" label-width="180px" label-position="left" v-loading="uploadLoading">
                    <el-form-item :label="$t('index.upload')" style="margin-right: 100px">
                        <el-upload
                                ref="upload"
                                class="avatar-uploader-login"
                                action="/api/blade-wems/upgrade/image/upload"
                                :multiple="false"
                                :show-file-list="true"
                                :headers="headers"
                                :auto-upload="false"
                                :limit="1"
                                :on-exceed="handleExceed"
                                :on-success="uploadSuccess"
                                :on-change="handleChange"
                                :on-error="handleError"
                                :before-upload="beforeAvatarUpload">
                            <i class="el-icon-upload avatar-uploader-icon"></i>
                            <div class="el-upload__tip" slot="tip"></div>
                        </el-upload>
                    </el-form-item>
                    <span style="margin-left: 148px"> </span>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="uploadVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="submitUpload">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { getUpgradebList, getDeviceManagementList, startUpgrade, stopUpgrade }from "@/api/spms";
    import i18n from "@/lang";
    import spmsweb from '@/config/spmsweb';
    import { Base64 } from 'js-base64/base64';
    import { getStore } from "@/utils/store";

    export default {
        name: "DevAlarmSys",
        data(){
            return{
                opacity: 0,
                loading: false,
                form: {

                },
                listLoading: false,
                list: [],
                size: 15,
                page: 1,
                total:0,

                active: 0,

                updateForm: {
                    deviceId: '',
                    deviceType: '',
                    l3DeviceId: '',
                    l2DeviceId: '',
                    l1DeviceId: '',
                    reset: 1,
                    fileDownloadUri: '',
                    fileCheckSum: '',
                    fileName: '',
                },

                rules: {
                    deviceId: [
                        { required: true, message: '请选择设备', trigger: 'change' }
                    ],
                    deviceType: [
                        { required: true, message: '请选择设备类型', trigger: 'change' }
                    ],

                    reset: [
                        { required: true, message: '请选择', trigger: 'change' }
                    ],
                    l1DeviceId: [
                        { required: true, message: '请填写序号', trigger: 'blur' }
                    ],
                    l2DeviceId: [
                        { required: true, message: '请填写序号', trigger: 'blur' }
                    ],
                    l3DeviceId: [
                        { required: true, message: '请填写序号', trigger: 'blur' }
                    ],
                },
                options: [],
                options1: [
                    { label: '总控BAU', value: 0},
                    { label: '主控BCU', value: 1},
                    { label: '从控BMU', value: 2},
                ],


                uploadVis: false,
                headers: {},
                fileList: [],
                uploadLoading: false,
                accept:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",

                formLoading: false,

                timer: null
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined){
                    return "--"
                }else {
                    return val
                }
            },
            confirmStatusF(val){
                switch (val) {
                    case 0:
                        return i18n.t("ems.alarm.new");
                    case 1:
                        return i18n.t("ems.alarm.confirm");
                    case 2:
                        return i18n.t("ems.alarm.remove");
                    case 3:
                        return i18n.t("ems.alarm.restore");
                    default:
                        return ""
                }
            },
            alarmLevelF(val){
                switch (val) {
                    case 1:
                        return i18n.t("ems.alarm.Level1");
                    case 2:
                        return i18n.t("ems.alarm.Level2");
                    case 3:
                        return i18n.t("ems.alarm.Level3");
                    default:
                        return ""
                }
            },
            systemTypeF(val){
                switch (val) {
                    case "CN":
                        return i18n.t("ems.alarm.EnergyStorage");
                    case "GF":
                        return i18n.t("ems.alarm.Photovoltaic");
                    case "FZ":
                        return i18n.t("ems.alarm.ControllableLoad");
                    case "BKKFZ":
                        return i18n.t("ems.alarm.UncontrolledLoad");
                    case "SD":
                        return i18n.t("ems.alarm.mains");
                    case "FD":
                        return i18n.t("ems.alarm.PowerGeneration");
                    default:
                        return ""
                }
            },
        },
        created(){
            this.headers = {
                Authorization: `Basic ${Base64.encode(
                    `${spmsweb.clientId}:${spmsweb.clientSecret}`
                )}`,
                "Blade-Auth": "bearer " + getStore({ name: "access_token" }),
                // 'Content-Type': 'application/json'
            };
        },
        mounted(){
            setTimeout(() => {
                this.opacity = 1;
            },200);
            getDeviceManagementList({ deviceTypes: 'DUI', current: 1, size: 500}).then(res => {
                this.options = res.data.data;
            })
        },
        methods: {
            onStop(id){
                this.$confirm(i18n.t("ems.alarm.sureyouwanttodothis"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    stopUpgrade(id).then(() =>  {
                        this.$message.success("操作成功！");
                        this.search();
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            },

            search(){
                this.page = 1;
                this.loadData();
            },
            resetForm() {
                this.$refs['updateForm'].resetFields();
            },
            submitForm() {
                this.$refs['updateForm'].validate((valid) => {
                    if (valid) {
                        console.log(this.updateForm)
                        if( this.updateForm.fileDownloadUri === '' || this.updateForm.fileCheckSum === '' ){
                            this.$message.warning("请上传文件！");
                            return false;
                        }
                        this.formLoading = true;
                        startUpgrade({...this.updateForm}).then(res => {
                            this.formLoading = false;
                            if(res && res.data && res.data.success){
                                this.$message.success("升级任务开始成功！");
                                this.active = 1;
                                this.form.deviceNo = this.options.find(i => { return i.id === this.updateForm.deviceId}).deviceNo;
                                this.loadData();
                                this.handleRefresh();
                            }
                            console.log(res);
                        }).catch(err => {
                            this.formLoading = false;
                            console.log(err)
                        })
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
            handleBtnChange(item){
                this.active = item;
                if(item === 1){
                    this.loadData();
                    this.handleRefresh();
                }else{
                    if(this.timer){
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }
            },
            loadData(){
                this.listLoading = true;
                getUpgradebList({size: this.size, current: this.page, deviceNo: this.form.deviceNo }).then(res => {
                    this.listLoading = false;
                    this.total = res.data.data.total;
                    this.list = res.data.data.records;
                }).catch(err => {
                    this.listLoading = false;
                    console.log(err)
                });
            },
            handleRefresh(){
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer = setInterval(() => {
                        getUpgradebList({size: this.size, current: this.page, deviceNo: this.form.deviceNo }).then(res => {
                            this.total = res.data.data.total;
                            this.list = res.data.data.records;
                        }).catch(err => {
                            console.log(err)
                        });
                    }, 3000)
                }else{
                    this.timer = setInterval(() => {
                        getUpgradebList({size: this.size, current: this.page, deviceNo: this.form.deviceNo }).then(res => {
                            this.total = res.data.data.total;
                            this.list = res.data.data.records;
                        }).catch(err => {
                            console.log(err)
                        });
                    }, 3000)
                }
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },


            submitUpload() {
                if (this.fileList.length === 0) {
                    this.$message.error("请选择文件！");
                    return;
                }
                this.$refs.upload.submit();
            },
            uploadSuccess(res) {
                console.log(res)
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: "操作成功！",
                    });
                    this.updateForm.fileDownloadUri = res.data.fileDownloadUri;
                    this.updateForm.fileCheckSum = res.data.fileCheckSum;
                    this.updateForm.fileName = res.data.fileName;

                    this.uploadVis = false;
                } else {
                    this.$refs.upload.clearFiles();
                    this.$message.error("上传文件失败！" +  res.msg);
                }
            },
            handleError(res) {
                console.log(JSON.stringify(res));
                this.$message.error("上传文件失败！" +  res.msg);
            },

            beforeAvatarUpload(file) {
                // console.log(file);
                // const isJPG = file.type.includes("sheet");
                // const isLt2M = file.size / 1024 / 1024 < 10;
                //
                // if (!isJPG) {
                //     this.$message.error("上传文件只能是 xls，wps 格式!");
                // }
                // if (!isLt2M) {
                //     this.$message.error("上传文件大小不能超过 10MB!");
                // }
                // return isJPG && isLt2M;
                return true
            },
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
                    files.length + fileList.length
                        } 个文件`
                );
            },
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
            },
            handleUpload(){
                this.uploadVis= true;
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";

    .btnClass{
        width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px
    }
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
            .navRight{
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                .creatTime{
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title
                    }
                }
                .btn{
                    height: 30px;
                    width: 85px;
                    border: $font_bright_blue_title solid 2px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: $font_bright_blue_title;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        margin-right: 5px;
                        font-size: 18px;
                    }
                }
            }
        }
        .content{
            padding: 20px;
            overflow: hidden;
            position: relative;
            .table_header {
                margin-top: 20px;
                height: 30px;
                margin-bottom: 20px;
            }
            .page{
                margin-top: 20px;
                height: 30px;
            }
            .strategy_main {
                height: 700px;
            }
        }

        .title_tab{
            display: flex;
            align-items: center;
            box-sizing: border-box;
            width: 240px;
            margin-top: 10px;
            margin-left: 10px;

            .title_tab_item{
                flex: 1;
                line-height: 30px;
                height: 30px;
                color: $_166_166_166;
                cursor: pointer;
                -webkit-tap-highlight-color:rgba(0,0,0,0);
                transition: all 300ms ease;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                padding-left: 10px;
                padding-right: 10px;
                font-size: 20px;
                text-align: center;
            }
            .title_tab_item:first-child{
                border-right: $_191_191_191 solid 1px;

            }
            .active{
                color: $font_bright_blue;
            }
        }

        .updatePanel{
            box-sizing: border-box;
            width: 100%;
            background-color: rgb(22,22,22);
            height: 700px;
            padding: 50px;
        }
    }
</style>